var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiverUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23C24.7956 23 25.5587 22.6839 26.1213 22.1213C26.6839 21.5587 27 20.7956 27 20C27 19.2044 26.6839 18.4413 26.1213 17.8787C25.5587 17.3161 24.7956 17 24 17C23.2044 17 22.4413 17.3161 21.8787 17.8787C21.3161 18.4413 21 19.2044 21 20C21 20.7956 21.3161 21.5587 21.8787 22.1213C22.4413 22.6839 23.2044 23 24 23ZM17 32C17 31.0807 17.1811 30.1705 17.5328 29.3212C17.8846 28.4719 18.4002 27.7003 19.0503 27.0503C19.7003 26.4002 20.4719 25.8846 21.3212 25.5328C22.1705 25.1811 23.0807 25 24 25C24.9193 25 25.8295 25.1811 26.6788 25.5328C27.5281 25.8846 28.2997 26.4002 28.9497 27.0503C29.5998 27.7003 30.1154 28.4719 30.4672 29.3212C30.8189 30.1705 31 31.0807 31 32H17Z",
    fill: "#40424B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverUser);
export default __webpack_public_path__ + "static/media/receiver-user.8aa7d85f.svg";
export { ForwardRef as ReactComponent };